import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { generateHostBreadcrumbs, HostTenantTopbar } from "./";
import { ErrorPage, PageBreadcrumbProps, PageLayout } from "../../";
import { PageTitleProvider, useAsync, useUrlParams } from "../../../hooks";
import { BreadcrumbProps, SidebarSubmenu } from "../../../components";
import { TenantService } from "../../../services";
import { router, routes } from "../../../app/routes";

function BaseLayout() {
  const tenantId = parseInt(useUrlParams("id"));
  const idMap = new Map([["id", tenantId?.toString() ?? ""]]);
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();

  const tenantService = new TenantService();
  const { value: tenant, loading, error } = useAsync(() => tenantService.get(tenantId), [tenantId]);

  useEffect(() => {
    const newBreadcrumbs:BreadcrumbProps = generateHostBreadcrumbs(location.pathname, tenantId, tenant?.name);
    setBreadcrumbs(newBreadcrumbs);

  }, [location.pathname, tenant, tenantId])

  if(loading) return <></>
  if(error){
    return <ErrorPage message={error.message} />
  }

  return (
     <PageLayout title={`Tenant: ${tenant?.name ?? ""}`} topbar={<HostTenantTopbar />} breadcrumbs={breadcrumbs}>
       <div className="row">
          <Outlet />
      </div>
     </PageLayout>

)
}

export function HostTenantLayout() {
  
  // Wrap the BaseUserLayout in a PageTitleProvider.
  // This prevents an error of the context not being initialized when the usePageTitle hook is called.

  return (
    <PageTitleProvider>
      <BaseLayout />
    </PageTitleProvider>
  );
}

export default HostTenantLayout
